import styles from "./Divider.module.scss";
import cx from "classnames";

const View = ({
  className,
  label,
  color = "yellow-1",
  opacity = 100,
  labelProps = {},
  light = false,
}: any) => {
  return (
    <div
      className={cx(
        "relative flex items-center py-5 text-black-1",
        styles.box,
        className
      )}
    >
      <div
        className={cx("flex-grow border-t", {
          [`border-${color}`]: !!color,
          [`opacity-${opacity}`]: !!opacity,
        })}
      ></div>
      {!!label && (
        <span
          className={cx(
            "flex-shrink mx-4",
            styles.label,
            labelProps.className,
            {
              ["text-black-1"]: light,
              ["text-white-1"]: !light,
            }
          )}
        >
          {label}
        </span>
      )}
      <div
        className={cx("flex-grow border-t", {
          [`border-${color}`]: !!color,
          [`opacity-${opacity}`]: !!opacity,
        })}
      ></div>
    </div>
  );
};
export default View;
